import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faRocket,
  faCutlery,
  faHandHoldingDollar,
  faListCheck,
} from "@fortawesome/free-solid-svg-icons";
import { CampaignListItem } from "interfaces/campaign-list-item";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

interface BoostProcurementProps {
  campaign: CampaignListItem;
}

type CardProps = {
  id: string;
  amountCash?: number;
  labelContext: React.ReactNode;
};

const CompCard: React.FC<CardProps> = ({ id, amountCash, labelContext }) => {
  const navigate = useNavigate();
  return (
    <motion.div
      whileHover={{ y: -5, borderColor: "#ff9f1c" }}
      className="opportunity-card campaign-boost-card"
      onClick={() => navigate(`/campaigns/edit/offer/${id}`)}
    >
      <div className="campaign-boost-card-tag">
        <div className="campaign-boost-card-avatars">
          <img
            src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-4.jpg"
            alt="Influencer"
            className="campaign-boost-card-avatar"
          />
          <img
            src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-5.jpg"
            alt="Influencer"
            className="campaign-boost-card-avatar"
          />
          <img
            src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-6.jpg"
            alt="Influencer"
            className="campaign-boost-card-avatar"
          />
        </div>
        <span>+{amountCash}</span>
      </div>
      <div className="campaign-boost-card-icon">
        <FontAwesomeIcon icon={faHandHoldingDollar} />
      </div>
      {labelContext}
    </motion.div>
  );
};

const BoostProcurement: React.FC<BoostProcurementProps> = ({ campaign }) => {
  const navigate = useNavigate();
  return (
    <div className="campaign-boost-performance">
      <div className="campaign-boost-header">
        <div className="campaign-boost-icon">
          <FontAwesomeIcon
            icon={faRocket}
            className="campaign-boost-icon-svg"
          />
        </div>
        <div className="campaign-boost-content">
          <h3 className="campaign-boost-title">Boost Procurement</h3>
          <p className="campaign-boost-desc">
            Your campaign has great potential! With{" "}
            <b>{campaign.viewedAmount?.toLocaleString() || "-"}</b> creators
            viewing your offer, let's unlock higher engagement with these proven
            strategies.
          </p>
        </div>
      </div>
      <div className="campaign-boost-cards">
        <div className="campaign-boost-cards-grid">
          {campaign.foodComp < 85 && (
            <motion.div
              whileHover={{ y: -5, borderColor: "#ff9f1c" }}
              className="opportunity-card campaign-boost-card"
              onClick={() => navigate(`/campaigns/edit/offer/${campaign._id}`)}
            >
              <div className="campaign-boost-card-tag">
                <div className="campaign-boost-card-avatars">
                  <img
                    src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-1.jpg"
                    alt="Influencer"
                    className="campaign-boost-card-avatar"
                  />
                  <img
                    src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-2.jpg"
                    alt="Influencer"
                    className="campaign-boost-card-avatar"
                  />
                  <img
                    src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-3.jpg"
                    alt="Influencer"
                    className="campaign-boost-card-avatar"
                  />
                </div>
                <span>+{campaign.amountFood}</span>
              </div>
              <div className="campaign-boost-card-icon">
                <FontAwesomeIcon icon={faCutlery} />
              </div>
              <div className="campaign-boost-card-title">
                Increase Product Comp
              </div>
              <div className="campaign-boost-card-desc">
                Reach more creators by matching the local benchmark of{" "}
                <span className="campaign-boost-card-highlight">$85</span>
              </div>
            </motion.div>
          )}
          {(!campaign.compensationTier.medium ||
            !campaign.compensationTier.large) && (
            <CompCard
              id={campaign._id}
              amountCash={
                !campaign.compensationTier.medium
                  ? campaign.amountMediumCash
                  : campaign.amountLargeCash
              }
              labelContext={
                !campaign.compensationTier.medium ? (
                  <>
                    <div className="campaign-boost-card-title">
                      Add Medium Tier
                    </div>
                    <div className="campaign-boost-card-desc">
                      Attract more creators with{" "}
                      <span className="campaign-boost-card-highlight blue">
                        $30-$100
                      </span>{" "}
                      cash incentives
                    </div>
                  </>
                ) : (
                  <>
                    <div className="campaign-boost-card-title">
                      Add Large Tier
                    </div>
                    <div className="campaign-boost-card-desc">
                      Attract more creators with{" "}
                      <span className="campaign-boost-card-highlight blue">
                        $100-$200
                      </span>{" "}
                      cash incentives
                    </div>
                  </>
                )
              }
            />
          )}

          {/* {(!campaign.compensationTier.medium ||
            !campaign.compensationTier.large) && (
            <motion.div
              whileHover={{ y: -5, borderColor: "#ff9f1c" }}
              className="opportunity-card campaign-boost-card"
              onClick={() => navigate(`/campaigns/edit/offer/${campaign._id}`)}
            >
              <div className="campaign-boost-card-tag">
                <div className="campaign-boost-card-avatars">
                  <img
                    src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-4.jpg"
                    alt="Influencer"
                    className="campaign-boost-card-avatar"
                  />
                  <img
                    src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-5.jpg"
                    alt="Influencer"
                    className="campaign-boost-card-avatar"
                  />
                  <img
                    src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-6.jpg"
                    alt="Influencer"
                    className="campaign-boost-card-avatar"
                  />
                </div>
                <span>
                  +
                  {!campaign.compensationTier.medium
                    ? campaign.amountMediumCash
                    : campaign.amountLargeCash}
                </span>
              </div>
              <div className="campaign-boost-card-icon">
                <FontAwesomeIcon icon={faHandHoldingDollar} />
              </div>
              <div className="campaign-boost-card-title">Add Premium Tier</div>
              <div className="campaign-boost-card-desc">
                Attract premium creators with{" "}
                <span className="campaign-boost-card-highlight blue">
                  $30-$100
                </span>{" "}
                cash incentives
              </div>
            </motion.div>
          )} */}
          {/* Card 3 */}
          <motion.div
            whileHover={{ y: -5, borderColor: "#ff9f1c" }}
            className="opportunity-card campaign-boost-card"
            onClick={() =>
              navigate(`/campaigns/edit/instructions/${campaign._id}`)
            }
          >
            <div className="campaign-boost-card-tag single">
              <span>+30% conversions</span>
            </div>
            <div className="campaign-boost-card-icon">
              <FontAwesomeIcon icon={faListCheck} />
            </div>
            <div className="campaign-boost-card-title">
              Simplify Instructions
            </div>
            <div className="campaign-boost-card-desc">
              Streamline requirements to boost participation.
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default BoostProcurement;
